import {faLock} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Space} from 'antd';
import {ReactElement} from 'react';

import {appRoute} from '../../../../../../app-route';
import {Text} from '../../../../../../component/text/text';
import {Page} from '../../../../../../layout/page/page';
import {Locale} from '../../../../../../provider/locale/locale';
import {useGoBackHook} from '../../../../../../service/navigation/go-back-hook';

import * as styles from './no-access-to-company.scss';

export function NoAccessToCompany(): ReactElement {
    const goBack = useGoBackHook(appRoute.myCompanies.path);

    return (
        <Page mainClassName={styles.NoAccessToCompany}>
            <Space align="center" direction="vertical" size="large">
                <FontAwesomeIcon className={styles.NoAccessToCompany_icon} icon={faLock} />
                <Text bolder large stringKey="COMPANY_FORM__ERROR__NO_ACCESS" />
                <Button onClick={goBack}>
                    <Locale stringKey="BUTTON__BACK" />
                </Button>
            </Space>
        </Page>
    );
}
